import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const NotFound = lazy(() => import('../pages/NotFound'));
const Home = lazy(() => import('../pages/home/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Tracking = lazy(() => import('../pages/tracking/page'));
const Reports = lazy(() => import('../pages/reports/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const FleetPage = lazy(() => import('../pages/fleet/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
        <p className="text-xs text-gray-400 font-medium">Chargement...</p>
      </div>
    </div>
  );
}

const routes: RouteObject[] = [
  { path: '/', element: <Suspense fallback={<PageLoader />}><Home /></Suspense> },
  { path: '/tracking', element: <Suspense fallback={<PageLoader />}><Tracking /></Suspense> },
  { path: '/reports', element: <Suspense fallback={<PageLoader />}><Reports /></Suspense> },
  { path: '/profile', element: <Suspense fallback={<PageLoader />}><Profile /></Suspense> },
  { path: '/fleet', element: <Suspense fallback={<PageLoader />}><FleetPage /></Suspense> },
  { path: '/admin', element: <Suspense fallback={<PageLoader />}><AdminPage /></Suspense> },
  { path: '/reset-password', element: <Suspense fallback={<PageLoader />}><ResetPasswordPage /></Suspense> },
  { path: '/support', element: <Suspense fallback={<PageLoader />}><SupportPage /></Suspense> },
  { path: '*', element: <Suspense fallback={<PageLoader />}><NotFound /></Suspense> },
];

export default routes;
